import { Ref } from "react";

import { RequiredAsterisk } from "../common";
import { DDQForm, FormConfig } from "../types";
import FormSection, { Mode } from "./FormSection";

export type Props = {
  register?: () => Ref<any>;
  form: DDQForm;
  mode: Mode;
};

export default function OwnershipFormSection({ register, mode, form }: Props) {
  const formConfig: FormConfig = {
    ownershipType: {
      type: "choice",
      label: <span>2A. Select type of ownership structure / entity type{RequiredAsterisk}</span>,
      choices: [
        { label: "Privately owned", value: "privatelyOwned" },
        { label: "Publicly listed", value: "publiclyListed" },
        { label: "Foundation", value: "foundation" },
        { label: "Not-for-Profit / Non-Profit", value: "noProfit" },
        { label: "Member Owned / Mutual", value: "memberOwned" },
        { label: "Government or State Owned by 25% or more", value: "stateOwned" },
        { label: "Natural Person", value: "naturalPerson" },
        { label: "Other", value: "other" },
      ],
    },
    ownershipTypeOther: {
      type: "text",
      label: "If other, please state the ownership / entity type",
    },
    detailsShareholdersPrivatelyOwned: {
      type: "text",
      label:
        "If privately owned, please provide details of shareholders or ultimate beneficial owners with a holding of 10% or more",
    },
  };

  return (
    <FormSection
      title="Section 2. Ownership structure"
      formConfig={formConfig}
      register={register}
      mode={mode}
      form={form}
    />
  );
}
